import { render, staticRenderFns } from "./CapTable.vue?vue&type=template&id=f723a004&scoped=true"
import script from "./CapTable.vue?vue&type=script&lang=js"
export * from "./CapTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f723a004",
  null
  
)

export default component.exports